var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57575_28081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 8.93044L12.7923 0.28125V3.6573H0V13.8604L5.85909 19.7195V14.2036H12.7923V17.5797L20 8.93044ZM4.68727 16.8905L2.00041 14.2036H4.68727V16.8905ZM1.17182 13.0318V4.82907H13.9642V3.51785L18.4747 8.93044L13.9642 14.3431V13.0318H1.17182V13.0318Z",
    fill: "#B4C1E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57575_28081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3f22ede3bbcd3e8022697b538e06f153.svg";
export { ForwardRef as ReactComponent };